import React, { useState } from 'react';
import './PriceManagement.css';

const PriceManagement = ({ products, setProducts, currentTime }) => {
  const [selectedProductForPriceList, setSelectedProductForPriceList] = useState(null);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [selectedProductForPrice, setSelectedProductForPrice] = useState(null);
  const [newPrice, setNewPrice] = useState('');

  const handleUpdatePrice = (product) => {
    setSelectedProductForPrice(product);
    setNewPrice(product.currentPrice.toString());
    setShowPriceModal(true);
  };

  const handleSavePrice = (e) => {
    e.preventDefault();
    const priceValue = parseFloat(newPrice);

    if (isNaN(priceValue) || priceValue < 0) {
      alert('Please enter a valid price');
      return;
    }

    setProducts(prev => prev.map(p => {
      if (p.id === selectedProductForPrice.id) {
        return {
          ...p,
          currentPrice: priceValue,
          priceHistory: [
            ...p.priceHistory,
            {
              price: priceValue,
              date: currentTime,
              note: 'Price updated'
            }
          ]
        };
      }
      return p;
    }));

    setShowPriceModal(false);
    setSelectedProductForPrice(null);
    setNewPrice('');
    alert('Price updated successfully!');
  };

  return (
    <div className="price-management-page">
      <div className="prices-header">
        <h3>Price Management</h3>
        <p>Update and track prices for all products</p>
      </div>

      <div className="prices-grid">
        {products.map(product => (
          <div key={product.id} className="price-management-card">
            <div className="price-card-header">
              <div>
                <h4>{product.name}</h4>
                <span className="product-subtitle">{product.englishName}</span>
              </div>
              <div className="current-price-badge">
                <span className="price-badge-label">Current Price</span>
                <span className="price-badge-value">₹{product.currentPrice.toFixed(2)}/quintal</span>
              </div>
            </div>

            <div className="price-actions-section">
              <button
                className="update-price-btn-main"
                onClick={() => handleUpdatePrice(product)}
              >
                <i className="fas fa-edit"></i> Update Price
              </button>
              <button
                className="view-history-btn"
                onClick={() => setSelectedProductForPriceList(
                  selectedProductForPriceList?.id === product.id ? null : product
                )}
              >
                <i className="fas fa-history"></i>
                {selectedProductForPriceList?.id === product.id ? 'Hide' : 'View'} History
              </button>
            </div>

            {selectedProductForPriceList?.id === product.id && (
              <div className="price-history-expanded">
                <h5>Price History</h5>
                {product.priceHistory && product.priceHistory.length > 0 ? (
                  <div className="history-timeline">
                    {product.priceHistory.slice().reverse().map((entry, index) => (
                      <div key={index} className="timeline-item">
                        <div className="timeline-marker"></div>
                        <div className="timeline-content">
                          <div className="timeline-price">₹{entry.price.toFixed(2)}</div>
                          <div className="timeline-note">{entry.note}</div>
                          <div className="timeline-date">{entry.date}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="no-history">No price history available</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Price Update Modal */}
      {showPriceModal && selectedProductForPrice && (
        <div className="pm-modal-overlay">
          <div className="pm-modal-content pm-price-modal">
            <div className="pm-modal-header">
              <h2>Update Price - {selectedProductForPrice.englishName}</h2>
              <button className="pm-close-button" onClick={() => {
                setShowPriceModal(false);
                setSelectedProductForPrice(null);
                setNewPrice('');
              }}>
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="pm-price-update-container">
              <div className="pm-current-price-display">
                <h3>Current Price</h3>
                <p className="pm-price-big">₹{selectedProductForPrice.currentPrice.toFixed(2)}</p>
                <span className="pm-per-unit">per quintal</span>
              </div>

              <form onSubmit={handleSavePrice} className="pm-price-form">
                <div className="pm-form-group">
                  <label>New Price (₹ per quintal)</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newPrice}
                    onChange={(e) => setNewPrice(e.target.value)}
                    placeholder="Enter new price"
                    required
                    autoFocus
                  />
                </div>
                <div className="pm-form-actions">
                  <button type="submit" className="pm-submit-btn">
                    <i className="fas fa-save"></i> Save Price
                  </button>
                  <button
                    type="button"
                    className="pm-cancel-btn"
                    onClick={() => {
                      setShowPriceModal(false);
                      setSelectedProductForPrice(null);
                      setNewPrice('');
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>

              {selectedProductForPrice.priceHistory && selectedProductForPrice.priceHistory.length > 0 && (
                <div className="pm-price-history-section">
                  <h3>Price History</h3>
                  <div className="pm-price-history-list">
                    {selectedProductForPrice.priceHistory.slice().reverse().map((entry, index) => (
                      <div key={index} className="pm-price-history-item">
                        <div className="pm-price-info">
                          <span className="pm-history-price">₹{entry.price.toFixed(2)}</span>
                          <span className="pm-history-note">{entry.note}</span>
                        </div>
                        <span className="pm-history-date">{entry.date}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PriceManagement;
